import { Bus } from "./Bus"
import { Cartridge } from "./Cartridge"
import { Cpu6502 } from "./Cpu6502"
import { Ppu2C02 } from "./Ppu2C02"

const cpu = new Cpu6502()
const ppu = new Ppu2C02()
export const nes = new Bus(cpu, ppu)
nes.insertCartridge(new Cartridge(new Uint8Array()))
